import React from 'react';
import { FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';

const ResponseDisplay = ({ response, error }) => {
  return (
    <div className="p-6 mt-8 shadow-inner bg-gray-50 rounded-2xl">
      {response && (
        <div className="p-6 transition-all bg-white border-l-4 border-green-500 shadow-md rounded-xl">
          <div className="flex items-center mb-4">
            <FaCheckCircle className="mr-2 text-2xl text-green-500" />
            <h3 className="text-xl font-semibold text-green-600">Success</h3>
          </div>
          <pre className="p-4 overflow-auto font-mono text-sm text-gray-800 bg-gray-100 rounded-lg">
            {JSON.stringify(response, null, 2)}
          </pre>
        </div>
      )}
      {error && (
        <div className="p-6 transition-all bg-white border-l-4 border-red-500 shadow-md rounded-xl">
          <div className="flex items-center mb-4">
            <FaExclamationCircle className="mr-2 text-2xl text-red-500" />
            <h3 className="text-xl font-semibold text-red-600">Error</h3>
          </div>
          <pre className="p-4 overflow-auto font-mono text-sm text-red-600 bg-gray-100 rounded-lg">
            {JSON.stringify(error, null, 2)}
          </pre>
        </div>
      )}
      {!response && !error && (
        <p className="text-center text-gray-500">No response yet. Try an action above.</p>
      )}
    </div>
  );
};

export default ResponseDisplay;